import { Component, OnInit, Inject } from '@angular/core';
import { CommonModule, DatePipe } from '@angular/common';
import { FormBuilder, FormGroup, Validators, ReactiveFormsModule, FormsModule } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialog, MatDialogConfig, MatDialogRef } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { MatRadioModule } from '@angular/material/radio';
import { MatButtonModule } from '@angular/material/button';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { Router } from '@angular/router';
import { ConfirmationmodalComponent } from '../../shared/components/confirmationmodal/confirmationmodal.component';
import { SuccessModalComponent } from '../../shared/components/success-modal/success-modal.component';
import { ConfirmationMode } from '../../shared/share';
import { MemberInsurerRestService } from '@app/modules/lps-member-login/services/member-insurer-rest.service';
import { validateVerticalPosition } from '@angular/cdk/overlay';
import { MemberInsurerServiceService } from '@app/modules/lps-member-login/services/member-insurer-service.service';
import { DateAdapter, MAT_DATE_FORMATS } from '@angular/material/core';
import { CustomDateAdapter } from '../../shared/pipes/custom-date-adapter';
import { MY_NATIVE_DATE_FORMATS } from '../../shared/pipes/date-format';
import { MatSliderModule, MatSlider } from '@angular/material/slider';
interface Step {
  id: number;
  title: string;
  status: 'complete' | 'in-progress' | 'pending';
  icon: string;
}

@Component({
  selector: 'app-add-applicant',
  standalone: true,
  imports: [
    CommonModule,
    ReactiveFormsModule,
    MatFormFieldModule,
    MatInputModule,
    MatSelectModule,
    MatRadioModule,
    MatButtonModule,
    MatCheckboxModule,
    MatSliderModule,
    FormsModule
  ],
  templateUrl: './add-applicant.component.html',
  styleUrls: ['./add-applicant.component.scss'],
  providers: [
    DatePipe, // optional, useful if you're formatting dates elsewhere
    { provide: DateAdapter, useClass: CustomDateAdapter },
    { provide: MAT_DATE_FORMATS, useValue: MY_NATIVE_DATE_FORMATS }
  ],
})
export class AddApplicantComponent implements OnInit {

  currentStep = 1;
  prefillData: any;
  prefillDataid: any;
  totalSteps = 4;
  showQuoteDetails = false;
  allQuestions: any[] = [];
  years:number[]=[1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18,19,20,21,22,23,24,25,26,27,28,29,30]
  isLoadingQuestions = true;

  popupTitle = 'Add Applicant';
  popupSubtitle = 'Please provide the information below to add a new applicant.';
  termYears = Array.from({ length: 10 }, (_, i) => i + 1);


  applicantForm!: FormGroup;
  preview: any;

  constructor(
    public dialogRef: MatDialogRef<AddApplicantComponent>,
    private fb: FormBuilder,
    private dialog: MatDialog,
    private router: Router,
    // public data :MatDialogRef<AddApplicantComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private restservice: MemberInsurerRestService,
    private memberService: MemberInsurerServiceService, private datepipe: DatePipe
  ) { }

  monthlyPremium: number = 0;
  totalAnnualCost: number = 0;
  totalPremiumtobepaid:number=0;

  // Call this method on form value changes or on "Get Quote" button click
  calculateQuote() {
    const sumInsured = this.applicantForm.get('coverageAmount')?.value || 0;
    const termInYears = this.applicantForm.get('policyType')?.value || 1;

    this.monthlyPremium = sumInsured * 0.0005;
    this.totalAnnualCost = this.monthlyPremium * 12;
    this.totalPremiumtobepaid=this.totalAnnualCost*this.applicantForm.value.policyType;
    

  }

  ngOnInit() {
    console.log("the dialog data is")
    console.log(this.data);

    this.initForm();
    this.getInsurerOrganisation();
    this.getAllQuestions();
    this.prefillDataid = this.data.id;
    this.getApplicantInfo(this.prefillDataid);


  }

  getApplicantInfo(data: any) {
    this.restservice.getApplicantInfo(data).subscribe({
      next: (response) => {
        console.log(response)
        this.prefillData = response;
        this.prefillform(this.prefillData)
      }
    })

  }

  getInsurerOrganisation(){
    const id =this.memberService.getLoginUserPrimaryId();
    console.log("the primary id is " + id)
    this.restservice.getOrganisationName(id).subscribe({
      next:(response)=>{
        console.log(response)

    
        this.applicantForm.patchValue({organasiationId:response[0].orgId})
        console.log(this.applicantForm.value)
      },error:(err)=>{
        console.log(err)
      }
    })
    
  }
  getAllQuestions() {
    this.isLoadingQuestions = true;
    this.restservice.getAllQuestions().subscribe({
      next: (value) => {
        console.log(value);
        this.allQuestions = value;
        this.isLoadingQuestions = false;
        console.log(this.allQuestions)
      },
      error: (error) => {
        console.error('Error loading questions:', error);
        this.isLoadingQuestions = false;
      }
    })
  }

  initForm() {
    this.applicantForm = this.fb.group({
      // Step 1: Personal Details
      surname: ['', Validators.required],
      organasiationId:['',Validators.required],
      firstName: ['', Validators.required],
      email: ['', Validators.required],
      phone: ['', Validators.required],

      address: ['', Validators.required],
      postalCode: ['', Validators.required],
      city: ['', Validators.required],
      gender: ['', Validators.required],
      dateOfBirth: ['', Validators.required],
      gpName: ['', Validators.required],
      surgery: ['', Validators.required],
      practiceAddress: ['', Validators.required],

      // Step 2: Health Questions
      height: ['', Validators.required],
      heightUnit: ['CM', ],
      weight: ['', Validators.required],
      weightUnit: ['KG', ],
      weightLoss: ['', Validators.required],
      weightLossCause: [''],
      smoking: ['', Validators.required],
      alcohol: ['', Validators.required],
      alcoholPeriod: ['', Validators.required],
      alcoholPeriodDetails: [''],
      drugs: ['', Validators.required],
      drugsPast: ['', Validators.required],

      // Additional Health Questions
      medicalConditions: ['', Validators.required],
      medicalConditionsDetails: [''],

      visitedGp: ['', Validators.required],
      Surgey: ['', Validators.required],
      hospitalized: ['', Validators.required],
    
    
     

      medications: ['', Validators.required],
      medicationsDetails: [''],
      MRI: ['', Validators.required],
       Blood: ['', Validators.required],
         ComplaintIllness: ['', Validators.required],
      ComplaintIllnessCause: ['', Validators.required],
      StillComplaint: ['', Validators.required],
        everBeenDoctor: ['', Validators.required],
      doctorPrescribe: ['', Validators.required],
      admitHospital: ['', Validators.required],

      surgeries: ['', ],
      surgeriesDetails: [''],
      familyHistory: ['',],
      familyHistoryDetails: [''],
      allergies: ['', ],
      allergiesDetails: [''],
      exercise: ['', ],
      exerciseDetails: [''],
      occupation: ['', ],
      travel: ['', ],
      travelDetails: [''],

      // Step 3: Quote
      coverageAmount: [200000, ], // Default min value
      policyType: [null, ],
      premiumAmount: ['', ],

      // Step 4: Consent
      termsAccepted: [false,],
      privacyAccepted: [false, ],
      marketingAccepted: [false],
      additionalInfo: ['']
    });

  }

  formatLabel(value: number): string {
    // Using a template literal to convert the number to a string
    return `£${value}`;
  }

  getQuote() {
    this.calculateQuote();
    this.showQuoteDetails = true;
  }


  closeDialog() {

    const successDialogConfig = new MatDialogConfig();
    successDialogConfig.width = '450px';
    successDialogConfig.disableClose = true;
    successDialogConfig.autoFocus = false;

    const successDialogRef = this.dialog.open(SuccessModalComponent, successDialogConfig);
    successDialogRef.componentInstance.title = 'Hold on a moment!';
    successDialogRef.componentInstance.message = 'It looks like you’ve got some unsaved changes. Be sure to save before leaving the page."';
    successDialogRef.componentInstance.continueButtonText = 'Save As Draft';
    successDialogRef.componentInstance.exitButtonText = 'Close Without Saving'
    successDialogRef.componentInstance.continueRoute = '/dashboard/distributor/applicants';

    successDialogRef.afterClosed().subscribe((isboolean) => {
      if (isboolean) {
        this.saveDraft();
      }
      else if (!isboolean) {
        this.dialogRef.close(true);
      }
    })


    // this.dialogRef.close(true)
  }



  steps: Step[] = [
    {
      id: 1,
      title: 'Personal Details',
      status: 'in-progress',
      icon: 'assets/gifs/Register.gif'
    },
    {
      id: 2,
      title: 'Health Questions',
      status: 'pending',
      icon: 'assets/gifs/health.gif'
    },
    {
      id: 3,
      title: 'Quote',
      status: 'pending',
      icon: 'assets/gifs/Tax.gif'
    },
    {
      id: 4,
      title: 'Consent',
      status: 'pending',
      icon: 'assets/gifs/Success.gif'
    }
  ];

  // Navigation methods
  nextStep(): void {
    if (this.currentStep < this.totalSteps) {
      this.steps[this.currentStep - 1].status = 'complete';
      this.currentStep++;
      this.steps[this.currentStep - 1].status = 'in-progress';
    }
  }

  previousStep(): void {
    if (this.currentStep > 1) {
      this.steps[this.currentStep - 1].status = 'pending';
      this.currentStep--;
      this.steps[this.currentStep - 1].status = 'in-progress';
    }
  }

  goToStep(stepNumber: number): void {
    // Allow navigation to any step
    this.steps.forEach((step, index) => {
      if (index + 1 < stepNumber) {
        step.status = 'complete';
      } else if (index + 1 === stepNumber) {
        step.status = 'in-progress';
      } else {
        step.status = 'pending';
      }
    });
    this.currentStep = stepNumber;
  }

  enumConfirmationMode = ConfirmationMode;
  prefillform(data: any) {
    console.log("the prefill data is");
    console.log(data)
    this.applicantForm.patchValue({
      address: data.applicant.address,
      email: data.applicant.email, firstName: data.applicant.firstName, lastName: data.applicant.lastName, phone: data.applicant.phone, postalCode: data.applicant.postalCode, city: data.applicant.city,

    })
  }

  // Form submission
  submitForm(): void {
    if (this.applicantForm) {
      console.log('Form submitted:', this.applicantForm.value);


      const payload = {
        "applicantId": null,
        "insurerOrg": this.applicantForm.value.organasiationId,
        // "insurerOg":'AD104A7B',
        "applicant": {

          "firstName": this.applicantForm.value.surname,
          "lastName": '',
          "email": this.applicantForm.value.email,
          "phone": this.applicantForm.value.phone,
          "createdby": this.memberService.getLoginUserId(),

          "address": this.applicantForm.value.address,
          "postalCode": this.applicantForm.value.postalCode,
          'city': this.applicantForm.value.city,
          "gender": this.applicantForm.value.gender,
          "dateOfBirth": this.applicantForm.get('dateOfBirth')?.value
          ? this.datepipe.transform(this.applicantForm.get('dateOfBirth')?.value, 'yyyy-MM-dd')
          : '',
          "gpName": this.applicantForm.value.gpName,
          "surgery": this.applicantForm.value.surgery,
          "practiceAddress": this.applicantForm.value.practiceAddress,
        },
        "answers": [
          {
            "questionId": "Q001",
            "answer": this.applicantForm.value.height
          },
          {
            "questionId": "Q002",
            "answer": this.applicantForm.value.weight,
            "text": this.applicantForm.value.weight
          },
          {
            "questionId": "Q003",
            "answer": this.applicantForm.value.weightLoss,
            "answerText": this.applicantForm.value.weightLossCause
          },
          {
            "questionId": "Q004",
            "answer": this.applicantForm.value.smoking
          },
          {
            "questionId": "Q005",
            "answer": this.applicantForm.value.alcohol
          },
          {
            "questionId": "Q006",
            "answer": this.applicantForm.value.alcoholPeriod,
            "answerText": this.applicantForm.value.alcoholPeriodDetails
          },
          {
            "questionId": "Q007",
            "answer": this.applicantForm.value.drugs
          },
          {
            "questionId": "Q008",
            "answer": this.applicantForm.value.drugsPast
          },
          {
            "questionId": "Q009",
            "answer": this.applicantForm.value.medicalConditions
          },
          {
            "questionId": "Q010",
            "answer": this.applicantForm.value.medications
          }, {
            "questionId": "Q011",
            "answer": this.applicantForm.value.surgeries
          }, {
            "questionId": "Q012",
            "answer": this.applicantForm.value.familyHistory
          },
          {
            "questionId": "Q013",
            "answer": this.applicantForm.value.hospitalized
          },
          {
            "questionId": "Q014",
            "answer": this.applicantForm.value.Surgey
          }, {
            "questionId": "Q015",
            "answer": this.applicantForm.value.visitedGp
          },
          {
            "questionId": "Q016",
            "answer": this.applicantForm.value.MRI
          }, {
            "questionId": "Q017",
            "answer": this.applicantForm.value.Blood
          }, {
            "questionId": "Q018",
            "answer": this.applicantForm.value.ComplaintIllness
          }, {
            "questionId": "Q019",
            "answer": this.applicantForm.value.ComplaintIllnessCause
          }, {
            "questionId": "Q020",
            "answer": this.applicantForm.value.StillComplaint
          }, {
            "questionId": "Q021",
            "answer": this.applicantForm.value.everBeenDoctor
          },
          {
            "questionId": "Q022",
            "answer": this.applicantForm.value.doctorPrescribe
          }, {
            "questionId": "Q023",
            "answer": this.applicantForm.value.admitHospital
          }
        ]
      }

      this.restservice.submit(payload).subscribe({
        next: (value) => {
          console.log(value);
          this.dialogRef.close()
          this.router.navigate(['/dashboard/distributor/applicants'])


        }
        ,
        error: (err) => {
          console.log(err)
        }
      })

      // Show confirmation dialog

      const successDialogConfig = new MatDialogConfig();
      successDialogConfig.width = '450px';
      successDialogConfig.disableClose = true;
      successDialogConfig.autoFocus = false;
      const successDialogRef = this.dialog.open(SuccessModalComponent, successDialogConfig);
      successDialogRef.componentInstance.title = 'Confirm';
      successDialogRef.componentInstance.message = 'Are You sure you want submit the application';
      successDialogRef.componentInstance.continueButtonText = 'Continue';
      successDialogRef.componentInstance.continueRoute = '/dashboard/distributor/applicants';


      successDialogRef.afterClosed().subscribe((isConfirmed: boolean) => {
        if (isConfirmed) {


          console.log(payload)
          successDialogRef.afterClosed().subscribe((isboolean) => {
            console.log(isboolean)
            if (isboolean) {
              // console.log(this.playload);
              this.restservice.submit(payload).subscribe({
                next: (value) => {
                  this.dialogRef.close(true);
                  this.router.navigate(['/dashboard/distributor/applicants'])
                }
                ,
                error: (err) => {
                  console.log(err)
                }
              })
            }


          })


          // Show success modal
          this.showSuccessModal();



        }
      });
    } else {
      this.markFormGroupTouched();
    }



  }

  // Show success modal
  private showSuccessModal(): void {
    const successDialogConfig = new MatDialogConfig();
    successDialogConfig.width = '450px';
    successDialogConfig.disableClose = true;
    successDialogConfig.autoFocus = false;

    const successDialogRef = this.dialog.open(SuccessModalComponent, successDialogConfig);
    successDialogRef.componentInstance.title = 'Success!';
    successDialogRef.componentInstance.message = 'Your case has been sent to OneFamily for their review and approval.';
    successDialogRef.componentInstance.continueButtonText = 'Continue';
    successDialogRef.componentInstance.continueRoute = '/dashboard/distributor/applicants';
    successDialogRef.afterClosed().subscribe((isboolean) => {
      if (isboolean) {
        this.dialogRef.close(true);
        this.router.navigate(['/dashboard/distributor/applicants']);
      }
    });
  }


  // Helper method to mark all form controls as touched
  markFormGroupTouched() {
    Object.keys(this.applicantForm.controls).forEach(key => {
      const control = this.applicantForm.get(key);
      control?.markAsTouched();
    });
  }

  // Helper methods
  isStepComplete(stepNumber: number): boolean {
    return this.steps[stepNumber - 1].status === 'complete';
  }

  isStepActive(stepNumber: number): boolean {
    return this.steps[stepNumber - 1].status === 'in-progress';
  }

  isStepPending(stepNumber: number): boolean {
    return this.steps[stepNumber - 1].status === 'pending';
  }

  selectRadioOption(controlName: string, value: string): void {
    this.applicantForm.get(controlName)?.setValue(value);
  }


  saveDraft() {
    console.log(this.applicantForm.valid);
    const payload = {
      "applicantId": null,
      "applicant": {
        "firstName": this.applicantForm.value.surname,
        "lastName": '',
        "email": this.applicantForm.value.email,
        "phone": this.applicantForm.value.phone,
        "createdby": this.memberService.getLoginUserId(),

        "address": this.applicantForm.value.address,
        "postalCode": this.applicantForm.value.postalCode,
        'city': this.applicantForm.value.city,
        "gender": this.applicantForm.value.gender,
        "dateOfBirth": this.applicantForm.get('dateOfBirth')?.value
          ? this.datepipe.transform(this.applicantForm.get('dateOfBirth')?.value, 'yyyy-MM-dd')
          : '',

        "gpName": this.applicantForm.value.gpName,
        "surgery": this.applicantForm.value.surgery,
        "practiceAddress": this.applicantForm.value.practiceAddress,
      },
      "answers": [
        {
          "questionId": "Q001",
          "answer": this.applicantForm.value.height
        },
        {
          "questionId": "Q002",
          "answer": this.applicantForm.value.weight,
          "text": this.applicantForm.value.weight
        },
        {
          "questionId": "Q003",
          "answer": this.applicantForm.value.weightLoss,
          "answerText": this.applicantForm.value.weightLossCause
        },
        {
          "questionId": "Q004",
          "answer": this.applicantForm.value.smoking
        },
        {
          "questionId": "Q005",
          "answer": this.applicantForm.value.alcohol
        },
        {
          "questionId": "Q006",
          "answer": this.applicantForm.value.alcoholPeriod,
          "answerText": this.applicantForm.value.alcoholPeriodDetails
        },
        {
          "questionId": "Q007",
          "answer": this.applicantForm.value.drugs
        },
        {
          "questionId": "Q008",
          "answer": this.applicantForm.value.drugsPast
        },
        {
          "questionId": "Q009",
          "answer": this.applicantForm.value.medicalConditions
        },
        {
          "questionId": "Q010",
          "answer": this.applicantForm.value.medications
        }, {
          "questionId": "Q011",
          "answer": this.applicantForm.value.surgeries
        }, {
          "questionId": "Q012",
          "answer": this.applicantForm.value.familyHistory
        },
        {
          "questionId": "Q013",
          "answer": this.applicantForm.value.hospitalized
        },
        {
          "questionId": "Q014",
          "answer": this.applicantForm.value.Surgey
        }, {
          "questionId": "Q015",
          "answer": this.applicantForm.value.visitedGp
        },
        {
          "questionId": "Q016",
          "answer": this.applicantForm.value.MRI
        }, {
          "questionId": "Q017",
          "answer": this.applicantForm.value.Blood
        }, {
          "questionId": "Q018",
          "answer": this.applicantForm.value.ComplaintIllness
        }, {
          "questionId": "Q019",
          "answer": this.applicantForm.value.ComplaintIllnessCause
        }, {
          "questionId": "Q020",
          "answer": this.applicantForm.value.StillComplaint
        }, {
          "questionId": "Q021",
          "answer": this.applicantForm.value.everBeenDoctor
        },
        {
          "questionId": "Q022",
          "answer": this.applicantForm.value.doctorPrescribe
        }, {
          "questionId": "Q023",
          "answer": this.applicantForm.value.admitHospital
        }
      ]
    }
    const successDialogConfig = new MatDialogConfig();
    successDialogConfig.width = '450px';
    successDialogConfig.disableClose = true;
    successDialogConfig.autoFocus = false;

    const successDialogRef = this.dialog.open(SuccessModalComponent, successDialogConfig);
    successDialogRef.componentInstance.title = 'Confirm';
    successDialogRef.componentInstance.message = 'Are You sure you want save as draft';
    successDialogRef.componentInstance.continueButtonText = 'Confirm';
    successDialogRef.componentInstance.continueRoute = '/dashboard/distributor/applicants';

    console.log(payload)
    successDialogRef.afterClosed().subscribe((isboolean) => {
      console.log(isboolean)
      if (isboolean) {
        // console.log(this.playload);
        this.restservice.saveDraft(payload).subscribe({
          next: (value) => {
            console.log(value);
            this.dialogRef.close()
            this.router.navigate(['/dashboard/distributor/applicants'])


          }
          ,
          error: (err) => {
            console.log(err)
          }
        })
      }


    })



    console.log(payload)
    successDialogRef.afterClosed().subscribe((isboolean) => {
      console.log(isboolean)
      if (isboolean) {
        // console.log(this.playload);
        this.restservice.saveDraft(payload).subscribe({
          next: (value) => {
            console.log(value);

          }
          ,
          error: (err) => {
            console.log(err)
          }
        })
      }


    })



  }
}
